const products = [
  {
    name: '47 Brand Clean Up Cap',
    image: '//merch.beefree.io/cdn/shop/files/Purple.jpg?v=1692812069&width=1946',
    price: '€18,95 EUR',
    SKU: 'BEEFREE-102',
    description: '100% Cotton, garment-washed twill, Unstructured, low-profile, six-panel, Pre-curved visor, 47\' snap slide buckle closure, Size: Adjustable, Color: Purple',
  },
  {
    name: 'BELLA+CANVAS Unisex Triblend Sponge Fleece Full-Zip Hoodie',
    image: '//merch.beefree.io/cdn/shop/files/SolidBlackTriblend2.jpg?v=1692811190&width=1445',
    SKU: 'BEEFREE-104',
    price: '€47,95 EUR',
    description: 'Retail fit, Tear-away label, Side seamed, Rib knit cuffs and hem, 8.2-ounce, 50/37.5/12.5 poly fleece/Airlume combed and ring spun cotton/rayon, 32 singles'
  },
  {
    name: 'BELLA + CANVAS - Women\'s Relaxed Triblend Short Sleeve V-Neck Tee',
    image: '//merch.beefree.io/cdn/shop/files/SolidNavyTriblend_60df1e9d-2fce-479e-9e17-5a4e2e455461.jpg?v=1692810027&width=1445',
    SKU: 'BEEFREE-106',
    price: '€13,95 EUR',
    description: '3.8 oz./yd², 52/25/25 airlume combed and ringspun cotton/polyester/rayon, 40 singles, Relaxed fit, Side seams, Tear-away label'
  },
  {
    name: '2.5 oz Espresso Cup Set',
    image: '//merch.beefree.io/cdn/shop/files/Dlab-Front-White-779139_EXP14SET-zoom.jpg?v=1692812394&width=1445',
    SKU: 'BEEFREE-106',
    price: '€5,95 EUR',
    description: '2.5 oz Expresso Cup Sets, Made from white Porcelain, Cup and Saucer included, Color: White'
  },
]

export default products
